var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-nav" }, [
    _c(
      "div",
      { staticClass: "page-nav-label" },
      [
        _vm.imageURL !== _vm.PopupPage.main &&
        _vm.imageURL !== _vm.PopupPage.jackpot
          ? _c(
              "span",
              {
                class: { hoverable: _vm.toURL },
                on: { click: _vm.handleURLCallback },
              },
              [
                _vm.popupLevel === 1
                  ? _c("img", {
                      staticClass: "menu-icon",
                      attrs: { src: _vm.getImgUrl(_vm.imageURL) },
                    })
                  : _c("img", {
                      staticClass: "menu-icon",
                      attrs: {
                        src: require("@/assets/images/history-detail.webp"),
                      },
                    }),
              ]
            )
          : _vm._e(),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }